// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2YGgu","col":"CardReaderDesc_col__3Ktnr","label":"CardReaderDesc_label__1PYgg"};